import { Check } from "@mui/icons-material";
import { HTMLAttributes } from "react";
import * as React from "react";


const CustomSelectOption = ({
  label,
  selected,
  props
} : {
  label: string,
  selected: boolean,
  props: React.HTMLAttributes<HTMLLIElement> & { key: any }
}) => {

  return (
    <li style={{display: "flex", justifyContent: "space-between"}} {...props} key={props.key}>
      <span> {label} </span>
      <span> {selected && <Check fontSize="small" color="primary"/>} </span>
    </li>
  )
}


export default CustomSelectOption